'use strict';

import {breakpoints, isMobile} from '../helpers/born.utils';

var dialog = require('../dialog');
var util = require('../util');
var progress = require('../progress');
var storeContext = {name:'storelocator'};
const STORE_OPTIONS = {
	listView	    : '.store-list-wrapper',
	searchContainer : '.search-container',
	searchInput     : 'input[name="qstoresrch"]',
	centerLat		: geCenterLat(),
	centerLng		: getCenterLng(),
	mapID			: 'storelocationmap',
	listViewWrap    : '#map-view-list',
	mapViewWrap		: '#map-view-mark',
	zoomSize		: getZoomSize(),
	searchButton    : '.store__search__trigger',
	mobHeadView		: '.store__mob--heading',
	pagination		: '.store-pagination',
	perPage			: 'input[name="store-per-page"]',
	searchItems		: '#store-search-items'
}; 

let gmapEl;
let inforObj = [];
let markersOnMap = [];
let gMarkers = [];
let gmInfoWindows = [];
let searchCallTimer = false;
let searchCallXhr = true;
let activeCount;
let gmlatlng = [];
let iconURL = '';

window.userCoordinates = false;

function getCenterCord()
{
	return {
        lat: geCenterLat(),
        lng: getCenterLng()
    };
}

function geCenterLat()
{
	var centerLat = getStoreSpecificField('centerLat');
	if(centerLat) {
	    return centerLat;
	}
    return 25.044633;
}

function getCenterLng()
{
	var centerLng = getStoreSpecificField('centerLng');
	if(centerLng) {
	    return centerLng;
	}
	
    return 55.118962;
}

function getZoomSize()
{
	var zoomSize = getStoreSpecificField('zoom');
	if(zoomSize) {
	    return zoomSize;
	}
	
    return 7;
}

function getStoreSpecificField(name)
{
    if(SitePreferences.SITE_SPECIFIC_CONFIGS) {
        var config = JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS).storeLocatorCenter;
        if(config && config[name] !== undefined && config[name]) {
            return config[name];
        }
    }
    
    return false;
}

function addGMarkerInfo(markers) {
    if(markers !== undefined) {
        markersOnMap = markers;
    }
    var btnClass = 'button button--primary btn-temp';
    var btnIcon= '';
    if(storeContext.name == 'pdpstore') {
        btnClass = 'store-dirlink map-address-details';
        btnIcon = '<span class="icon-left"></span>';
    }
    for (var i = 0; i < markersOnMap.length; i++) {
    	var gcord = markersOnMap[i].coordinates;
    	if(gcord.lat != null && gcord.lng != null) {
	        var contentString = '<div class="store-details">' +
	            '<div class="store-image-container">' +
	            '<img src="' + markersOnMap[i].image + '" alt="store-image" class="store-image" />' +
	            '</div>' +
	            '<div class="store-details-container" data-storeid="'+markersOnMap[i].id+'">' +
	            '<h1 class="store-name text-uppercase text-nowrap">' + markersOnMap[i].name + '</h1>' +
	            '<h3 class="store-location text-nowrap">' + markersOnMap[i].address + '</h3>' +
	            '<span class="store-timing text-uppercase">' + markersOnMap[i].timing + '</span>' +
	            '<span class="store-contact">' + markersOnMap[i].contact + '</span>' +
	            '<a href="http://maps.google.com/maps?hl=en&f=q&q=' + encodeURI(markersOnMap[i].geolocation) + '" target="_blank" class="'+btnClass+'">'+Resources.STORE_INFO_BUTTON+' '+btnIcon+'</a>' +
	            '</div>' +
	            '</div>';

			iconURL = getIconUrl();	
			let marker = new google.maps.Marker({
	            position: markersOnMap[i].coordinates,
	            map: gmapEl,
				icon: iconURL
	        });
	
	        let infowindow = new google.maps.InfoWindow({
	            content: contentString,
	            maxWidth: 400
	        });
	        if(storeContext.name == 'pdpstore') {
                google.maps.event.addListener(infowindow, 'domready', function () {
                    trackStoreEvent();
                });
            }
			marker.addListener('click', function () {
			  closeOtherInfo();
			  infowindow.open(marker.get('map'), marker);
			      inforObj[0] = infowindow;
			});
			
			marker.addListener('mouseover', function () {
			  closeOtherInfo();
			  infowindow.open(marker.get('map'), marker);
			      inforObj[0] = infowindow;
			});
			  
	        gMarkers.push(marker);
	        
	        var latlng = new google.maps.LatLng(gcord.lat,gcord.lng);
	        gmlatlng.push(latlng);
    	}
    }
    
    if(gmlatlng.length > 0) {
    	var latlngbounds = new google.maps.LatLngBounds();
        for (var i = 0; i < gmlatlng.length; i++) {
            latlngbounds.extend(gmlatlng[i]);
        }
        gmapEl.fitBounds(latlngbounds);
        gmapEl.setZoom(getZoomSize());
    }
    
    trackStoreEvent();
}

function addGMarkers() {
	iconURL = getIconUrl();	
    for (var i = 0; i < markersOnMap.length; i++) {
    	var gcord = markersOnMap[i].coordinates;
    	if(gcord.lat != null && gcord.lng != null) {
	        let marker = new google.maps.Marker({
	            position: markersOnMap[i].coordinates,
	            map: gmapEl,
				icon: iconURL
	        });
	        gMarkers.push(marker);
    	}
    }
}

function showListView()
{
	$(STORE_OPTIONS.listView).show();
	showPagination();
}

function hideListView()
{
	$(STORE_OPTIONS.listView).hide();
	hidePagination();
}

function removeActiveView()
{
	$('.map-view-options .icon')
		.removeClass('set--active');
}

function setActiveView()
{
	var activeEl = false;
	
	$('.map-view-options .icon').each(function(){
		if($(this).hasClass('set--active')) {
			activeEl = $(this);
			return false;
		}
	});
	var listViewWrapOption = STORE_OPTIONS.listViewWrap;
	if(activeEl) {
		if(listViewWrapOption.indexOf(activeEl.attr('id')) !== -1 || 
				listViewWrapOption.indexOf(activeEl.attr('class')) !== -1) {
			setListView();
		} else {
			setMapView();
		}
	}
	
}

function closeOtherInfo() {
    if (inforObj.length > 0) {
        inforObj[0].set("marker", null);
        inforObj[0].close();
        inforObj.length = 0;
    }
}

function searchStores(q, init, count)
{
	var siteSpecificConfigs = JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS);
	var showAllStoresOnLoad = false;
	if(siteSpecificConfigs && typeof siteSpecificConfigs.showAllStoresOnLoad !== undefined){
		showAllStoresOnLoad = siteSpecificConfigs.showAllStoresOnLoad;
	}
	if(!q.trim() && !showAllStoresOnLoad) {
		return;
	}
	var findUrl = Urls.searchStores;
	if(!findUrl) {
		return;
	}
	$.ajax({
        type: 'POST',
        url: findUrl,
        data:{q:q, start:count},
        beforeSend:function() {
        	$(STORE_OPTIONS.listView).empty();
        	$(STORE_OPTIONS.mobHeadView).empty();
        	deleteGMarkers();
        	$(STORE_OPTIONS.pagination).hide();
        	removeActiveList();
        	refreshGMap();
        },
        success: function(response) { 
			if(response.status == true) {
			    let markersOnMap = [];
				markersOnMap = response.markersOnMap;
				addGMarkerInfo(markersOnMap);
				setPagination(response.pagination);
				if(init == true) {
					togglePageButton();
				}
				if(window.innerWidth < breakpoints.mobile) {
					if(response.isEmpty == true) {
						$(STORE_OPTIONS.mobHeadView).html(response.listView);
					} else {
						$(STORE_OPTIONS.listView)
							.html(response.listView);
						hidePagination();
					}
				} else {
					$(STORE_OPTIONS.listView)
						.html(response.listView);
				}
				setActiveView();
			} 
        },
        error:function() {
        	
        },
        complete:function() {
        	initStorePageEvent();
        }
    })
}

function getStoresByAddress()
{
	var findUrl = Urls.listStoresByAddress;
	if(!findUrl) {
		return;
	}
	
	var selectedSize = $('.swatch__link');
	if(!selectedSize || selectedSize.length <= 0) {
	    return;
	}
	
	var variantAttr = '';
	var variantAttrEl = $('input[name="variantAttr"]');
	if(variantAttrEl.length > 0) {
		variantAttr = variantAttrEl.val();	
	}
	var sizeList = [];
	selectedSize.each(function (){
	    var aEl = $(this).find('a');
	    if(aEl && aEl.length > 0 && aEl.data('id') && aEl.data('productid')) {
	        sizeList.push({
	            size:aEl.data('id'),
	            productId:aEl.data('productid')
	        });
	    }
	});
	if(sizeList.length <=0) {
	    return;
	}
	$.ajax({
        type: 'POST',
        url: findUrl,
        data:{size: JSON.stringify(sizeList), variantAttr:variantAttr},
        beforeSend:function() {
        	beforeStoreSearch();
        	progress.show('.chkstore_modal');
        },
        success: function(response) { 
			if(response.status == true) {
				markersOnMap = response.markersOnMap;
				addGMarkerInfo();
				setPagination(response.pagination);
				togglePageButton();
				resetPagination(0);
				$(STORE_OPTIONS.listView)
						.html(response.listView);
			    if(response.pagination.total != undefined) {
			        var total = parseInt(response.pagination.total);
			        if(total> 0) {
			            $('#'+STORE_OPTIONS.mapID).show();
			            $(".storelist-scroll").css('height',"");
			        }
			        $('.search-view-count')
                        .show()
                        .find('.value')
                        .html(markersOnMap.length);
                    checkGeolocation();    
                    sortStores('city');
                    storeAvailabilityResultsGAEvent(markersOnMap.length);
			    }
			    removeActiveList();
			} 
			progress.hide();
        },
        error:function() {
        	progress.hide();
        	$(STORE_OPTIONS.listView).html('<div class="error-info">'+Resources.STORE_AVAILABLITY_FAIL+'</div>');
        },
        complete:function() {
        	initStorePageEvent();
        	progress.hide();
        	trackStoreEvent();
        }
    });
}

function storeAvailabilityResultsGAEvent(total) {
	var resultCount = total > 0 ? total :'No result';
	var user = dataLayer.find(o => o.user != null).user;
	var product = dataLayer.find(o => o.product != null).product;
	dataLayer.push({
	    'event': 'custom_event',
	    'eventCategory': 'PDP',
	    'eventAction': 'check_in_store_availability_result',
	    'eventLabel': 'check in store availability result view - ' + resultCount, //Number of results if more than 0 then number else No result
	    'productName': product ? product.name : '',  // Name of product page
	    'country': window.GlobalAttributes.COUNTRY,
	    'language': window.GlobalAttributes.LANGUAGE,
	    'screenName' : 'PDP',
	    'userType':  user.user_id!='' ? 'logged-in' : 'logged-out',
	    'userId': user.user_id!=''? user.user_id : ''  
	});
}

function setGMapOnAll(map) 
{
	for (let i = 0; i < gMarkers.length; i++) {
		gMarkers[i].setMap(map);
	}
}

function clearGMarkers() 
{
  setGMapOnAll(null);
}

function deleteGMarkers() {
  clearGMarkers();
  gMarkers = [];
}

function initGmap(id)
{
	return new google.maps.Map(document.getElementById(id), {
        zoom: getZoomSize(),
        center: getCenterCord()
    });
}

function refreshGMap()
{
	google.maps.event.trigger(gmapEl, 'resize');
	gmapEl.setZoom(gmapEl.getZoom());
}

function initializeEvents()
{
	$(document).ready(function () {
	    gmapEl = initGmap(STORE_OPTIONS.mapID);
	    
		$(STORE_OPTIONS.searchContainer).submit(function (event) {
			event.preventDefault();
			event.stopImmediatePropagation();
	        event.stopPropagation();
	        searchStoreByQuery(true);
		});
		
		$(STORE_OPTIONS.searchButton).on('click',function(event) {
			event.preventDefault();
			event.stopImmediatePropagation();
	        event.stopPropagation();
			searchStoreByQuery(true);
		});
		
		$(STORE_OPTIONS.listViewWrap).on('click',function(){
			setListView();
		});
		
		$(STORE_OPTIONS.mapViewWrap).on('click',function(){
			setMapView();
		});
		
		var searchEl = $(STORE_OPTIONS.searchInput);
	    var q = searchEl.val();
		searchStores(q,true,0);
		
	});
	
	window.addEventListener("resize", switchMapListView);
	
	document.addEventListener("click", function (e) {
		removeActiveList();
	});
	
	storeSearchByName();
	
}


function initializePDPEvents()
{
	$(document).ready(function () {
	    gmapEl = initGmap(STORE_OPTIONS.mapID);
		$(STORE_OPTIONS.searchContainer).submit(function (event) {
			event.preventDefault();
			event.stopImmediatePropagation();
	        event.stopPropagation();
	        searchStoreByAddress();
		});
		
		$(STORE_OPTIONS.searchButton).on('click',function(event) {
			event.preventDefault();
			event.stopImmediatePropagation();
	        event.stopPropagation();
			searchStoreByAddress();
		});
		$('.store-sortby-list').on('change',function (){
		    sortStores(this.value);
		})
	});
	searchByAddress();
	storeContext.name = 'pdpstore';
}

function initStorePageEvent()
{
	$('.store-page-next, .store-page-prev').on('click',function(event){
		event.preventDefault();
		event.stopImmediatePropagation();
        event.stopPropagation();
		if($(this).hasClass('store-page-next')) {
			callPageEl('next');
		} else {
			callPageEl('prev');
		}
	});
}

function callPageEl(type)
{
	var total = $('input[name="total-count"]').val();
	var current = $('input[name="current-count"]');
	total = parseInt(total)
	var next;
	if(type == 'next') {
		next = parseInt(current.val())+1;
		if((total-1) > next) {
			$('.store-page-next').removeAttr('disabled');
		} else {
			$('.store-page-next').attr('disabled', true);
		}
		if(next <= 0) {
			$('.store-page-prev').attr('disabled',true);
		} else {
			$('.store-page-prev').removeAttr('disabled');
		}
	} else {
		next = parseInt(current.val())-1;
		if(next <= 0) {
			$('.store-page-prev').attr('disabled',true);
		}
		if(next < total) {
			
			$('.store-page-next').removeAttr('disabled');
		}
		if(next == total) {
			$('.store-page-prev').attr('disabled',true);
		}
	}
	
	current.val(next);
	getStorePagination(next);
	setPagination({
		current:next,
		total:total
	});
	scrollToTopListView();
	closeOtherInfo();
}

function scrollToTopListView()
{
	var scrollEl = $('.chkstore_wrapper .storelist-scroll');
	if(scrollEl.length > 0) {
	    $(".storelist-scroll").scrollTop(0);
	} else {
	    var scrollTop = $(STORE_OPTIONS.listView).offset().top;
	
        if(window.innerWidth < breakpoints.mobile) {
            scrollTop = scrollTop-70;
        } else {
            scrollTop = scrollTop-10;
        }
        scrollTop = scrollTop-10-getTopHeight();
        $('html, body').animate({
            scrollTop: scrollTop
        }, 1000);
	}
}

function getTopHeight()
{
    var mainEl = $('#store-locator');
    if(!mainEl || mainEl.length <=0) {
        return 0;
    }
    var prev = mainEl.prev();
    if(!prev || prev.length <=0) {
        return 0;
    }
    var height = prev.height();
    if(height) {
        height = parseInt(height);
    }
    if(height > 100) {
        return (height-50);
    }
    return height;
}

function setPagination(pagination)
{
	var current = parseInt(pagination.current);
	var total = parseInt(pagination.total);

	if(total > 0) {
		$(STORE_OPTIONS.pagination).show();
	} else {
		$(STORE_OPTIONS.pagination).hide();
	}
	var displayCurrent = current;
	if(total > current) {
		displayCurrent = current+1;
	}
	var pageEl = $(STORE_OPTIONS.pagination);
	pageEl.find(".store-page-start").html(displayCurrent);
	pageEl.find(".store-page-end").html(total);
	pageEl.find("input[name='total-count']").val(total);
	pageEl.find("input[name='current-count']").val(current);
	
}

function getStorePagination(count)
{
	var perPage= $(STORE_OPTIONS.perPage).val();
	var $storeEl=jQuery('.store-list-wrapper .store-details');
	var storeElCount=$storeEl.length;
	var index=count*perPage;
	$storeEl.hide();
	for(var i=0;i<perPage;i++){
		$storeEl.eq(index+i).show();
	}
}
function togglePageButton()
{
	var pageEl = $(STORE_OPTIONS.pagination);
	var total = pageEl.find("input[name='total-count']").val();
	total = parseInt(total);
	$('.store-page-prev').attr('disabled',true);

	if(total > 1) {
		$('.store-page-next').removeAttr('disabled');
	} else {
		$('.store-page-next').attr('disabled',true);
	}
}

function searchStoreByQuery(init, count)
{
	if(init === undefined) {
		init = false;
	}
	
	if(count === undefined) {
		count = 0;
	}
	var searchEl = $(STORE_OPTIONS.searchInput);
    var q = searchEl.val();
    q = q.trim();
    if(!q){
    	searchEl.addClass('error');
    	return;
    }
    searchEl.blur();
    searchEl.removeClass('error');
    searchStores(q, init, count);
}

function searchStoreByAddress()
{
    var searchEl = $(STORE_OPTIONS.searchInput);
    var q = searchEl.val();
    q = q.trim();
    if(!q){
    	searchEl.addClass('error');
    	return;
    }
    searchEl.blur();
    searchEl.removeClass('error');
    getStoresByAddress();
    
    if (typeof pdpStoreStockCheckPushEvent !== "undefined") { 
        var data = [];
        data.push({key:'location',value:q});
        pdpStoreStockCheckPushEvent('store_search_button', data);
    }
}

function setListView()
{
	if(window.innerWidth < breakpoints.mobile) {
		showListView();
		removeActiveView();
		$(STORE_OPTIONS.listViewWrap).addClass('set--active');
	} else {
		setDesktopView();
	}
}

function setMapView()
{
	if(window.innerWidth < breakpoints.mobile) {
		hideListView();
		removeActiveView();
		$(STORE_OPTIONS.mapViewWrap).addClass('set--active');
		
	} else {
		setDesktopView();
	}
}

function setDesktopView()
{
	showListView();
}

function showPagination()
{
	var pageEl = $(STORE_OPTIONS.pagination);
	var total = pageEl.find("input[name='total-count']").val();
	if(total > 0) {
		pageEl.show();
	} else {
		pageEl.hide();
	}
}

function hidePagination()
{
	$(STORE_OPTIONS.pagination).hide();
}

function switchMapListView()
{
	if(window.innerWidth >= breakpoints.mobile) {
		setDesktopView();
	} else {
		setActiveView();
	}
}

function storeSearchByName() {
	storeSearchFieldBind('name');
}

function searchByAddress() {
    storeSearchFieldBind('address');
}

function storeSearchFieldBind(typeName)
{
    var searchEl = $(STORE_OPTIONS.searchInput);
	searchEl.bind({
	  input: function(e) {
	      var val = this.value;
	      removeActiveList();
	      if (!val) { return false;}
	      val = val.trim();
	      activeCount = -1;
	      window.clearTimeout(searchCallTimer);
	      searchCallTimer = window.setTimeout(function(){
	    	  removeActiveList();
	    	  val = $(STORE_OPTIONS.searchInput).val();
	    	  if(val && val.length >= 2) {
	    	    if(typeName == 'address') {
	    	        getItemsFromAddress(val); 
	    	    } else {
	    	        getItemsFromearch(val); 
	    	    }
	    	  }
          }, 400);
	  },
	  keydown: function(e) {
	      var x = document.getElementById("store-search-items");
	      if (x) x = x.getElementsByTagName("div");
	      if (e.keyCode == 40) {
	        activeCount++;
	        setActiveEl(x);
	      } else if (e.keyCode == 38) {
	        activeCount--;
	        setActiveEl(x);
	      } else if (e.keyCode == 13) {
	        e.preventDefault();
	        if (activeCount > -1) {
	          if (x) x[activeCount].click();
	        }
	      }
	  },
	  keyup:function(e) {
		  var event = e || window.event;
		  var keyCode = event.keyCode || event.which;
		  if (keyCode == 13) {
			  var q = this.value;
			  removeActiveList();
			  if(typeName == 'address') {
                  searchStoreByAddress();
              } else {
                  searchStoreByQuery(true);
              }
			  if(q && q.trim()) {
				  $(this).blur();
			  }
		  }
		 return true;
	  }
	});
}
function setActiveEl(el) {
    if (!el) {
    	return false;
    }
    removeActiveEl(el);
    if (activeCount >=el.length) {
    	activeCount = 0;
    }
    if (activeCount < 0) {
    	activeCount = (el.length - 1);
    }
    el[activeCount].classList.add("store__search--active");
}
  
function removeActiveEl(el) {
    for (var i = 0; i < el.length; i++) {
      el[i].classList.remove("store__search--active");
    }
}
  
function removeActiveList() {
	$(STORE_OPTIONS.searchItems).empty();
}

function getItemsFromearch(q)
{
	var findUrl = Urls.searchStoresByName;
	if(!findUrl) {
		return;
	}
	var itemsEl = $(STORE_OPTIONS.searchItems);
	$.ajax({
        type: 'POST',
        url: findUrl,
        data:{q:q},
        beforeSend:function() {
        	itemsEl.empty();
        },
        success: function(response) { 
			if(response.status == true) {
				var listArr = response.storesArr;
				if(listArr.length <=0) {
					return;
				}
				var searchEl =  $(STORE_OPTIONS.searchInput);
				$(STORE_OPTIONS.searchItems).empty();
				for(i=0;i<listArr.length;i++) {
		          var el = document.createElement("DIV");
		          el.innerHTML = '<span>'+listArr[i].name+'</span>';
		          el.innerHTML += "<input type='hidden' value='" + listArr[i].name + "'>";
		          el.addEventListener("click", function(e) {
		        	  var inputVal = this.getElementsByTagName("input")[0].value;
		        	  searchEl.val(inputVal);
		              removeActiveList();
		              $(STORE_OPTIONS.searchButton).trigger('click');
		          });
		          itemsEl.append(el);
		        }
			}

        },
        error:function() {
        },
        complete:function() {
        }
    })
}

function getItemsFromAddress(q)
{
	var findUrl = Urls.searchStoresByAddress;
	if(!findUrl) {
		return;
	}
	
	var itemsEl = $(STORE_OPTIONS.searchItems);
	$.ajax({
        type: 'POST',
        url: findUrl,
        data:{q:q},
        beforeSend:function() {
        	itemsEl.empty();
        },
        success: function(response) { 
			if(response.status == true) {
				var listArr = response.storesArr;
				if(listArr.length <=0) {
					return;
				}
				var searchEl =  $(STORE_OPTIONS.searchInput);
				$(STORE_OPTIONS.searchItems).empty();
				for(i=0;i<listArr.length;i++) {
		          var el = document.createElement("DIV");
		          el.innerHTML = '<span>'+listArr[i].name+'</span>';
		          el.innerHTML += "<input type='hidden' value='" + listArr[i].name + "'>";
		          el.addEventListener("click", function(e) {
		        	  var inputVal = this.getElementsByTagName("input")[0].value;
		        	  searchEl.val(inputVal);
		              removeActiveList();
		              $(STORE_OPTIONS.searchButton).trigger('click');
		          });
		          itemsEl.append(el);
		        }
			}

        },
        error:function() {
        },
        complete:function() {
        }
    })
}
function initStoreAppointment()
{
    $(document).ready(function () {
	    gmapEl = initGmap(STORE_OPTIONS.mapID);

		$(STORE_OPTIONS.searchContainer).submit(function (event) {
			event.preventDefault();
			event.stopImmediatePropagation();
	        event.stopPropagation();
	        triggerAppointmentSearch();
		});

		$(STORE_OPTIONS.searchButton).on('click',function(event) {
			event.preventDefault();
			event.stopImmediatePropagation();
	        event.stopPropagation();
			triggerAppointmentSearch();
		});
        searchStoreAppointment();
	});
	
}

function triggerAppointmentSearch()
{
    var searchEl = $(STORE_OPTIONS.searchInput);
    var q = searchEl.val();
    searchAppointmentByQuery(q);
}

function searchStoreAppointment()
{
    searchAppointmentByQuery('', true);
}

function searchAppointmentByQuery(searchKey, init)
{
    try {
        if(searchKey === undefined) {
            searchKey = '';
        }
        if(init === undefined) {
            init = false;
        }
        var items = filterAppointment(searchKey, init);
        $(STORE_OPTIONS.listView).html("");
        clearGMarkers();
        if(items && items.length >0) {
            markersOnMap = items;
            addMarkeronMap();
            
            items.forEach(function(v,key){
               bulildStoreInfo(v);
            });
            showPagination();
            var perPage= $(STORE_OPTIONS.perPage).val();
            setPagination({
                current:0,
                total:Math.ceil(items.length/perPage)
            });
            togglePageButton();
            initStorePageEvent();
            getStorePagination(0);
        } else {
            showEmptyResult();
            hidePagination();
        }
        
        progress.hide();
    } catch (e) {
        progress.hide();
    }
}

function filterAppointment(searchKey, init)
{
    var list = (window.storeInfo!==undefined && window.storeInfo.markersOnMap!==undefined)? window.storeInfo.markersOnMap:[];
    if(init === true) {
        return list;
    }
    var name = searchKey.toUpperCase();
    return list.filter(function(entry) {
        return entry.address.toUpperCase().indexOf(name) !== -1;
    });
}

function bulildStoreInfo(item)
{
    var activeEl = $('input[name$="storeappointment_storeID"]').val();
    var activeClass="";
    var checkedClass="";
    if(activeEl == item.id) {
        activeClass="active-store";
        checkedClass = "checked";
    }
    var el = '<div class="store-details storelist_wa '+activeClass+'" id="store-'+item.id+'" data-storeid="'+item.id+'">' +
        '<div class="control-label checkbox '+checkedClass+'"></div>'+
        '<div class="store-details-container">' +
        '<h1 class="store-name text-uppercase text-nowrap">'+item.name+' </h1>' +
        '<h3 class="store-location">'+item.address+'</h3>' +
        '<span class="store-timing text-uppercase">'+item.timing+'</span>' +
        '<span class="store-contact">'+item.contact+'</span>' +
        '<input type="hidden" name="" class="store_details_bkapp" value="'+item.name+'|'+item.address+'|'+item.contact+'" />' +
        '</div>' +
        '</div>';
    $(STORE_OPTIONS.listView).append(el);
}

function showEmptyResult()
{
    var emptyEl = $('input[name="empty_result"]');
    if(emptyEl.length > 0) {
        var el = '<div class="empty-store-result">' +
            emptyEl.val()+
        '</div>';
        $(STORE_OPTIONS.listView).html(el);
    }
}

function addMarkeronMap() {
	iconURL = getIconUrl();	
       
    for (var i = 0; i < markersOnMap.length; i++) {
    	var gcord = markersOnMap[i].coordinates;
    	if(gcord.lat != null && gcord.lng != null) {
	        let marker = new google.maps.Marker({
	            position: markersOnMap[i].coordinates,
	            map: gmapEl,
				icon: iconURL
	        });
	        
	        gMarkers.push(marker);
	        var latlng = new google.maps.LatLng(gcord.lat,gcord.lng);
	        gmlatlng.push(latlng);
    	}
    }
    if(gmlatlng.length > 0) {
    	var latlngbounds = new google.maps.LatLngBounds();
        for (var i = 0; i < gmlatlng.length; i++) {
            latlngbounds.extend(gmlatlng[i]);
        }
        gmapEl.fitBounds(latlngbounds);
    }
}

function beforeStoreSearch()
{
    deleteGMarkers();
    $(STORE_OPTIONS.pagination).hide();
    removeActiveList();
    refreshGMap();
    $('#'+STORE_OPTIONS.mapID).hide();
    $('.search-view-count').hide();
    $(".storelist-scroll").css('height',"auto");
    $(STORE_OPTIONS.listView).empty();
}

function resetStoreSearch()
{
    beforeStoreSearch();
    $(STORE_OPTIONS.searchInput).val('');
}

function trackStoreEvent()
{
    if($('.map-address-details').length > 0) {
        $('.map-address-details').click(function (){
            sendStoreEvent(this);
        });
    }
}

function sendStoreEvent(el)
{
    var storeWrapEl = $(el).closest('.store-details-container');
    if(storeWrapEl.length > 0 && storeWrapEl.data('storeid') != null) {
        if (typeof pdpStoreStockCheckPushEvent !== "undefined") { 
            var data = [];
            var storeId = storeWrapEl.data('storeid');
            data.push({key:'SFCC_store_ID',value:storeId});
            pdpStoreStockCheckPushEvent('store_selection', data);
        }
    } 
}

function initPDPStoreData()
{
    getStoresByAddress();
}

function getLocationDistance(lat1, lng1, lat2, lng2) {
    if(lat1 && lng1 && lat2 && lng2) {
        var eRad = 6371;
        var lat = degreeToRadius(lat2 - lat1);
        var lng = degreeToRadius(lng2 - lng1);
        var calc = Math.sin(lat / 2) * Math.sin(lat / 2) +
            Math.cos(degreeToRadius(lat1)) * Math.cos(degreeToRadius(lat2)) *
            Math.sin(lng / 2) * Math.sin(lng / 2);
        var total = 2 * Math.atan2(Math.sqrt(calc), Math.sqrt(1 - calc));
        return eRad * total;
    }
    return 99999;
}

function degreeToRadius(deg) {
    return deg * (Math.PI / 180);
}

function sortStores(sort) {
    if(sort == 'location') {
        sortStoresByLocation();
    } else {
        sortStoreByCity();
    }
}

function sortStoresByLocation()
{
    if (!initGeolocation()) {
        return;
    }
}

function checkGeolocation() {

    $('.store-location-help').hide();
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function() {
        }, removeSortLocation);
        return true;
    }
    removeSortLocation();
    return false;
}

function initGeolocation() {

    $('.store-location-help').hide();
    if (navigator.geolocation) {
        let options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };
        navigator.geolocation.getCurrentPosition(success, fail, options);
        return true;
    }
    removeSortLocation();
    return false;
}

function success(position) {
    window.userCoordinates = {
        lng: position.coords.longitude,
        lat: position.coords.latitude
    };
    var storesIds = markersOnMap;
    for (let i = 0; i < storesIds.length; i++) {
        let distance = getLocationDistance(window.userCoordinates.lat,
            window.userCoordinates.lng, storesIds[i].coordinates.lat,
            storesIds[i].coordinates.lng);
        storesIds[i].distance = distance;
    }

    storesIds.sort(function (a, b) {
        return a.distance - b.distance;
    });
    var ids = [];
    for(i=0;i<storesIds.length;i++) {
        ids.push(storesIds[i].id);
    }
    sortStoreByLatLng(ids);
}

function fail() {
    removeSortLocation();
}

function removeSortLocation()
{
    $(".store-sortby-list option[value='location']").attr({'disabled':true, 'title':'Enable location'});
    $(".store-sortby-list").selectric('refresh').trigger('change');
    $('.store-location-help').show();
}

function sortStoreByLatLng(ids) {
 
    var wrapEls = $('.store-list-wrapper .store-details');
    var elements = [];
    var item;
    $.each(ids, function(i, position) {
        item = wrapEls.find('[data-storeid="'+position+'"]').closest('.store-details');
        elements.push(item);
    });
    
    $('.store-list-wrapper').html(elements);
    resetPagination();
}

function sortStoreByCity()
{
    let wrapEl = document.querySelector(STORE_OPTIONS.listView);
    [].slice.call(wrapEl.children)
    .sort(function (a, b) {
        var tx1 = a.querySelector('.store-location');
        var tx2 = b.querySelector('.store-location');
        return tx1.innerHTML == tx2.innerHTML
            ? 0
            : (tx1.innerHTML > tx2.innerHTML ? 1 : -1);
    }).forEach(function (el) {
        wrapEl.appendChild(el);
    });
    resetPagination();
}         

function resetPagination()
{
    var perPage= $(STORE_OPTIONS.perPage).val();
    var wrapEl = $('.store-list-wrapper .store-details');
    var length = wrapEl.length;
    wrapEl.hide();
    setPagination({
        current:0,
        total:Math.ceil(length/perPage)
    });
    togglePageButton();
    getStorePagination(0);
}
function getIconUrl() {
	var iconURL ="";
	var imgEl  = document.querySelector('input[name="imageurl"]');
	if(imgEl) {
		iconURL= imgEl.value;
	}
	return iconURL;
}
  
exports.init = function () {
    initializeEvents();
};

exports.initializePDPEvents = initializePDPEvents;
exports.initStoreAppointment = initStoreAppointment;
exports.resetStoreSearch = resetStoreSearch;
exports.initPDPStoreData = initPDPStoreData;




// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/storelocator.js